// extracted by mini-css-extract-plugin
export default {"container":"_2er5SM6fSlMwCq9jqI3UcD","bottomContainer":"_1SATFehClre9hdAq9dd2uE","topContainer":"_22H96N66NIgDvgp7-mptAf"};